/* Publish by EComposer at 2026-10-21 18:53:20*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-y47ji2gs6za"]=  window.__ectimmers["ecom-y47ji2gs6za"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-y47ji2gs6za').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y47ji2gs6za', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dap02skbc2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dap02skbc2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a8nm45j21sg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a8nm45j21sg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-25qq49gycru').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-25qq49gycru', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5okz93psmyw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5okz93psmyw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jajqc8udwdh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jajqc8udwdh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5qw6juercbw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5qw6juercbw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ek66gup8617').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ek66gup8617', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6r9tqjaj47w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6r9tqjaj47w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vyp5e0z3gvg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vyp5e0z3gvg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-87o8lwa93pn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-87o8lwa93pn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d60x71dzlls').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d60x71dzlls', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-argfmhlz93').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-argfmhlz93', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mycjry9asi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mycjry9asi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5s9nzawig2m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5s9nzawig2m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mbzcxnxi5w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mbzcxnxi5w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xbyjkn2gy5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xbyjkn2gy5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i2nef4siuom').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i2nef4siuom', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k2dq2ge2cj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k2dq2ge2cj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-haynr4y4pum').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-haynr4y4pum', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zm4rpbmrgn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zm4rpbmrgn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-osbfmp9tetp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-osbfmp9tetp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n82ff3sxhb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n82ff3sxhb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-umwjuh324un').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-umwjuh324un', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4y1se1v0i1d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4y1se1v0i1d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rny69ubbwk9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rny69ubbwk9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-znwpsh7vcp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-znwpsh7vcp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lv56d8uca7g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lv56d8uca7g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-od2kpkin98a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-od2kpkin98a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-29kj8g29587').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-29kj8g29587', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b7x76rtngm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b7x76rtngm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n7tzzq01ww').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n7tzzq01ww', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6zlnhe286sm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6zlnhe286sm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ukkg2lw0tb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ukkg2lw0tb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-12e3nyle679').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-12e3nyle679', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c1dsnsavt8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c1dsnsavt8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ar0biyx3v7v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ar0biyx3v7v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bhzszoxujmg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bhzszoxujmg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h5ehjn20dqb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h5ehjn20dqb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0l4qrx23d8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0l4qrx23d8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8ruozrnldl6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ruozrnldl6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uazyly6m519').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uazyly6m519', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qf580seglvs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qf580seglvs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vn2xqplffqn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vn2xqplffqn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4tuim2sa1nb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4tuim2sa1nb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6d4l6qnjund').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6d4l6qnjund', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-advxok9o1s7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-advxok9o1s7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dapjhovcp5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dapjhovcp5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yzqyrnft8kk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yzqyrnft8kk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zo6ktfq5y3k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zo6ktfq5y3k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w2sc4t40w5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w2sc4t40w5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mgplwv8k2re').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mgplwv8k2re', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c83dldq81h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c83dldq81h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ki8nz5n7khi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ki8nz5n7khi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vg94xmhh11e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vg94xmhh11e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4724i54so2o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4724i54so2o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-453ly6lk2n2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-453ly6lk2n2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-loh9dy8mjl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-loh9dy8mjl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j2gjh98c41l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j2gjh98c41l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-843of4t121c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-843of4t121c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i7nui2wdf3a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i7nui2wdf3a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-su44htqh1b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-su44htqh1b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mna52bd037q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mna52bd037q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zp79sek2q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zp79sek2q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-igxskgh5wfe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-igxskgh5wfe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4u00wymtia8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4u00wymtia8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hx7tdwlj2zi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hx7tdwlj2zi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h6dryeztwos').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h6dryeztwos', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p7e3v2zophg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p7e3v2zophg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e11yx9t5m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e11yx9t5m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4ge4igei2ln').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4ge4igei2ln', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z1utl2k3tq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z1utl2k3tq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ngkevh9gfa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ngkevh9gfa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ijtdeh7j49a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ijtdeh7j49a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hy925mtpdxm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hy925mtpdxm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o3vj8osf0s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o3vj8osf0s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jw1g7okmshs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jw1g7okmshs', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-09w8jyrzg3vm"]=  window.__ectimmers["ecom-09w8jyrzg3vm"] || {};
if(!this.$el)return;const t=this.$el,e=function(o){if(window.EComModal)return o();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&o()});return}let n=0;const r= window.__ectimmers["ecom-09w8jyrzg3vm"]["heqj02cgz"] = setInterval(function(){window.EComModal?(clearInterval(r),o()):++n>=300&&clearInterval(r)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var i=this.$el.querySelectorAll("[ecom-modal]"),s=this.id;i.length&&e(function(){new window.EComModal(i,{cssClass:["ecom-container-lightbox-"+s]})})}if(this.settings.link!=="lightbox"&&this.settings.link!=="custom"&&/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){let o=t.querySelector(".ecom-image-picture-hover"),n=t.querySelector(".ecom-image-picture.ecom-image-has-hover");if(!o||!n)return;o.addEventListener("click",function(){n.classList.add("image-active"),o.classList.add("image-hidden")}),n.addEventListener("click",function(){n.classList.remove("image-active"),o.classList.remove("image-hidden")})}

                    });
                    
                        document.querySelectorAll('.ecom-09w8jyrzg3vm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-09w8jyrzg3vm', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vehki2sal4s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vehki2sal4s', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-av824jau987').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-av824jau987', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eyyhrzhzt4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eyyhrzhzt4', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y7hq1nmxatn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y7hq1nmxatn', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n6255cwzqe9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n6255cwzqe9', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2x5c0mna4ll').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2x5c0mna4ll', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wj5xu9q15s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wj5xu9q15s', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7c9d95mpaag').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7c9d95mpaag', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sjzvo9o7lia').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sjzvo9o7lia', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3m8lyf78dj7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3m8lyf78dj7', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9x9smx85wx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9x9smx85wx', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q5gndnngui').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q5gndnngui', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2w0zcoxlyij').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2w0zcoxlyij', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kahgrtncyd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kahgrtncyd', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q0taidmtgo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q0taidmtgo', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u56ujzjeo4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u56ujzjeo4', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q1g8aalw9cg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q1g8aalw9cg', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7d9kqzy7pk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7d9kqzy7pk', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ci12ftmtqvi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ci12ftmtqvi', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3dgdtk1o7y2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3dgdtk1o7y2', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8ukibe4oc8e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ukibe4oc8e', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-11w99g6cddue').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-11w99g6cddue', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z7o6b0i9pjd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z7o6b0i9pjd', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4xi30g9ecd9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4xi30g9ecd9', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j92o7qxoj2b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j92o7qxoj2b', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qkc8zbhxrp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qkc8zbhxrp', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jkslm176ycn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jkslm176ycn', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-77v1jgw5yv8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-77v1jgw5yv8', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2sp6v4la2ue').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2sp6v4la2ue', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kmam67k9z2k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kmam67k9z2k', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3eryax4c954').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3eryax4c954', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d13ldz5ib1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d13ldz5ib1', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xk0s6m72xkb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xk0s6m72xkb', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bc86hfcxj6i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bc86hfcxj6i', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f6kc1520c3s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f6kc1520c3s', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n6m7puigfz9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n6m7puigfz9', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kqibmugfavs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kqibmugfavs', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x41ud9j3stk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x41ud9j3stk', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q4rrf3q1dwa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q4rrf3q1dwa', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q5zrdx0hhec').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q5zrdx0hhec', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x5fgz3lqjah').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x5fgz3lqjah', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ye9ymh2rn2p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ye9ymh2rn2p', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cu76n842hrj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cu76n842hrj', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j17c9eyjvb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j17c9eyjvb', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h5m2mxvx2z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h5m2mxvx2z', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7lukf31l6tp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7lukf31l6tp', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-67dyjfbjjmv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-67dyjfbjjmv', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gfeav32rogo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gfeav32rogo', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i15djxx6uh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i15djxx6uh', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p1g8l8aofu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p1g8l8aofu', settings: {"lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-okjt1oqrke').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-okjt1oqrke', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7ykwd5kf3n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7ykwd5kf3n', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bkynrh71fkg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bkynrh71fkg', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-02hemd6dgx7m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-02hemd6dgx7m', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g6izivo4pe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g6izivo4pe', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-opqlnwy7wke').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-opqlnwy7wke', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y65lyk00axo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y65lyk00axo', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rtswc94nu3m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rtswc94nu3m', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qg71oks1icq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qg71oks1icq', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ra1qgbxyoxa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ra1qgbxyoxa', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tuql86yf7n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tuql86yf7n', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ekme3s47lfr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ekme3s47lfr', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1p08tm5evow').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1p08tm5evow', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q3o3dns9cl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q3o3dns9cl', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bp9hyqe3vww').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bp9hyqe3vww', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rttm2frq7br').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rttm2frq7br', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xkmio7njxr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xkmio7njxr', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3wxlwoh5sv2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3wxlwoh5sv2', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7btnuh4dh3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7btnuh4dh3', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vq6vygwoheb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vq6vygwoheb', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tt2fxx0bx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tt2fxx0bx', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gqnttubqoo5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gqnttubqoo5', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rynmz0b2hgh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rynmz0b2hgh', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}